import { render, staticRenderFns } from "./MatchSignupFlowSection.vue?vue&type=template&id=9fa2d6ae&scoped=true"
import script from "./MatchSignupFlowSection.vue?vue&type=script&lang=js"
export * from "./MatchSignupFlowSection.vue?vue&type=script&lang=js"
import style0 from "./MatchSignupFlowSection.vue?vue&type=style&index=0&id=9fa2d6ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa2d6ae",
  null
  
)

export default component.exports